var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcUserUnlock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.119 4c-2.017 0-3.62 1.584-3.62 3.5h7.667c.921 0 1.667.746 1.667 1.667v6.666c0 .92-.746 1.667-1.667 1.667H5.833c-.92 0-1.667-.746-1.667-1.667V9.167c0-.689.418-1.28 1.014-1.534a.67.67 0 0 1-.014-.133c0-2.687 2.236-4.833 4.953-4.833 1.472 0 2.8.628 3.708 1.629a.667.667 0 1 1-.988.896A3.662 3.662 0 0 0 10.12 4zm4.047 4.833H5.833a.333.333 0 0 0-.333.334v6.666c0 .184.15.333.333.333h8.334c.184 0 .333-.149.333-.333V9.167a.333.333 0 0 0-.334-.334zM9.333 11.5a.667.667 0 1 1 1.333 0v1.192A1.249 1.249 0 0 1 10 15a1.25 1.25 0 0 1-.666-2.308.67.67 0 0 1 0-.026V11.5z",
    fill: "#212121"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUserUnlock);
export default __webpack_public_path__ + "static/media/ic-user-unlock.080aff3bfad31deaeceb7ebac7641fc2.svg";
export { ForwardRef as ReactComponent };